import { render } from "./CategoriesContent.vue?vue&type=template&id=4e9e995c&scoped=true"
import script from "./CategoriesContent.vue?vue&type=script&lang=js"
export * from "./CategoriesContent.vue?vue&type=script&lang=js"

import "./CategoriesContent.vue?vue&type=style&index=0&id=4e9e995c&lang=scss&scoped=true"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e9e995c"]])

export default __exports__